webpackJsonp([277973826130771],{

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Log4JPage = function (_Component) {
	    _inherits(Log4JPage, _Component);
	
	    function Log4JPage() {
	        _classCallCheck(this, Log4JPage);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Log4JPage.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'referral-container' },
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Datasert - Realfire and Log4j2 Vulnerability' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'content' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Realfire and Log4j2 Vulnerability'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'TLDR: Realfire is NOT impacted by the vulnerability'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'One of the sub-component of the Realfire uses log4j Version 1 which is ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://logging.apache.org/log4j/2.x/security.html' },
	                        'not impacted'
	                    ),
	                    '  by this vulnerability hence no action is required to be taken at this time'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://gist.github.com/brsanthu/2e649716653f1be8dac440fb65c5653a' },
	                        'Here'
	                    ),
	                    ' is complete list of files included in the Realfire v5.3.2 (our latest version).'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'If you have any questions, please reach out to us at support@datasert.com'
	                )
	            )
	        );
	    };
	
	    return Log4JPage;
	}(_react.Component);
	
	exports.default = Log4JPage;
	module.exports = exports['default'];

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-products-realfire-log-4-j-2-jsx-fbe3a94c5612706975cc.js